import { useMutation } from '@apollo/client/react'
import * as Sentry from '@sentry/react'
import { toast } from 'sonner'
import {
  PortalAddPackageToBusinessDocument,
  PortalBusinessPackagesDocument,
  type PortalAddPackageToBusinessMutation,
  type PortalAddPackageToBusinessMutationVariables,
} from '@/graphql/generated/graphql'

/**
 * Alta de un servicio (paquete) en un negocio. Refetch de `portalBusinessPackages`
 * para reflejar el cambio en la lista. NO muestra toast de éxito: el llamador
 * decide el aviso (en altas en lote, un solo toast tras el último).
 */
export function useAddPackageToBusiness(businessId: string) {
  const [mutate, { loading, error }] = useMutation<
    PortalAddPackageToBusinessMutation,
    PortalAddPackageToBusinessMutationVariables
  >(PortalAddPackageToBusinessDocument, {
    refetchQueries: [
      { query: PortalBusinessPackagesDocument, variables: { businessId } },
    ],
    awaitRefetchQueries: true,
    onError: (err) => {
      Sentry.captureException(err, {
        tags: { operation: 'PortalAddPackageToBusiness' },
      })
      toast.error('No se pudo agregar el servicio', { description: err.message })
    },
  })

  const addPackage = async (packageServiceId: number, observations = '') => {
    const result = await mutate({
      variables: { input: { businessId, packageServiceId, observations } },
    })
    return result.data?.portalAddPackageToBusiness ?? null
  }

  return { addPackage, loading, error }
}
